import {
  FileExcelOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
} from "@ant-design/icons";
import { memo, useCallback, type ReactNode } from "react";
import type { Document } from "types/document";
import { downloadWithOriginalName } from "utils/download";
import { $urlImage } from "utils/url";

export type BDocumentListItemProps = {
  item: Document;
};

const getFileTypeLabel = (item: Document) => {
  if (item.fileType?.trim()) {
    return item.fileType.trim().toUpperCase();
  }

  const fromName = item.fileName.split(".").pop()?.trim();
  if (fromName) {
    return fromName.toUpperCase();
  }

  const fromMime = item.mimeType?.split("/").pop()?.trim();
  if (fromMime) {
    return fromMime.toUpperCase();
  }

  return "FILE";
};

const getFileIcon = (fileType: string): ReactNode => {
  switch (fileType) {
    case "PDF":
      return <FilePdfOutlined className="b-document-list__icon" />;
    case "DOC":
    case "DOCX":
      return <FileWordOutlined className="b-document-list__icon" />;
    case "XLS":
    case "XLSX":
    case "CSV":
      return <FileExcelOutlined className="b-document-list__icon" />;
    case "TXT":
    case "MD":
      return <FileTextOutlined className="b-document-list__icon" />;
    default:
      return <FileOutlined className="b-document-list__icon" />;
  }
};

const BDocumentListItemView = ({ item }: BDocumentListItemProps) => {
  const typeLabel = getFileTypeLabel(item);

  const handleClick = useCallback(() => {
    // console.log(item);
    // if (!item.filePath) {
    //   return;
    // }
    // window.open($urlImage(item.filePath), "_blank", "noopener,noreferrer");
    downloadWithOriginalName({
      name: item.fileName,
      path: item.filePath,
    });
  }, [item.filePath]);

  return (
    <li className="b-document-list__row">
      <button
        type="button"
        className="b-document-list__item"
        onClick={handleClick}
      >
        {getFileIcon(typeLabel)}
        <span className="b-document-list__name">
          {item.name || item.fileName}
        </span>
        <span className="b-document-list__type">{typeLabel}</span>
      </button>
    </li>
  );
};

export default memo(BDocumentListItemView);
